import { useSuspenseQuery } from '@tanstack/react-query'

import { hostPayQueries } from '@/entities/host-pay'
import { formatCurrency } from '@/shared/lib'
import { Dashboard } from '@/widgets/dashboard'

export const HostPayReady = () => {
  const {
    data: hostPayReady,
    refetch: refetchHostPayReady,
    isFetching: isFetchingHostPayReady,
  } = useSuspenseQuery({
    ...hostPayQueries.hostPayReady({ onlySummary: true }),
    meta: {
      useCustomHandling: true,
    },
  })

  const {
    settlementSummary: {
      totalAmount: hostPayTotalAmount,
      totalCount: hostPayTotalCount,
    },
    currentTime: hostPayCurrentTime,
  } = hostPayReady

  return (
    <Dashboard.Card>
      <Dashboard.Header>
        <Dashboard.Title>정산 예정 임대료</Dashboard.Title>
        <Dashboard.Refresh
          time={hostPayCurrentTime}
          onRefresh={refetchHostPayReady}
          isRefreshing={isFetchingHostPayReady}
        />
      </Dashboard.Header>
      <Dashboard.Content columns={1}>
        <Dashboard.Item href="/host/pay" className="flex items-center gap-6">
          <span className="typo-body1 font-medium text-black">
            총 {hostPayTotalCount}건
          </span>
          <span className="typo-title1 flex-1 text-right font-bold text-black">
            {formatCurrency(hostPayTotalAmount)}원
          </span>
        </Dashboard.Item>
      </Dashboard.Content>
    </Dashboard.Card>
  )
}
